import { flatten } from 'flat';
import React from 'react';
import { createIntl, createIntlCache, RawIntlProvider } from 'react-intl';
import { LANG } from 'shared/src/constants';
import { simplifiedLocale } from 'shared/src/utils/locale';
import en_US from './i18n/en_US.json';
import ky_KG from './i18n/ky_KG.json';
import ru_RU from './i18n/ru_RU.json';
import tg_TJ from './i18n/tg_TJ.json';
import uz_UZ from './i18n/uz_UZ.json';

const locales = {
  ru_RU,
  ky_KG,
  en_US,
  tg_TJ,
  uz_UZ,
};
const poll = window.__pollData;

let lang = poll?.lang || LANG.ru_RU;
if (!(lang in locales)) lang = LANG.ru_RU;
const simpleLocale = simplifiedLocale(lang);
document.documentElement.lang = simpleLocale;

const locale = locales[lang];

function getMessages() {
  const messages: Record<string, string> = flatten(locale);
  const i18nOverrideFlattened = poll?.i18nOverride && flatten(poll.i18nOverride);

  if (i18nOverrideFlattened && typeof i18nOverrideFlattened === 'object' && Object.keys(i18nOverrideFlattened).length) {
    return { ...messages, ...i18nOverrideFlattened };
  }
  return messages;
}

const IntlCache = createIntlCache();
const intl = createIntl({ locale: simpleLocale, messages: getMessages() }, IntlCache);

export const LocaleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <RawIntlProvider value={intl}>{children}</RawIntlProvider>;
};

export default intl;
